<template>
  <q-dialog
    v-model="dialog"
    persistent
    style="max-width: 500px"
    class="custom-font text-uppercase"
    maximized
  >
    <q-card style="width:500px" class="pragma-black">
      <q-form @submit.prevent="rendirItem()">
        <q-card-section class="q-pa-none">
          <q-toolbar class="bg-pragma text-white shadow-2 rounded-borders">
            <q-btn flat label="Rendir Ítem" />
            <q-space />
            <q-btn
              v-if="!form.edit"
              icon="clear"
              @click="closeDialog()"
              flat
            ></q-btn>
          </q-toolbar>
        </q-card-section>
        <q-card-section>
          <div class="row q-gutter-y-sm">
            <div class="col-xs-12">
              <q-select
                v-model="form.unidad_id"
                :options="unidades"
                option-label="descripcion"
                option-value="id"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
                label="Unidad"
                options-dense
                emit-value
                map-options
              ></q-select>
            </div>
            <div class="col-xs-12">
              <q-select
                v-model="form.tipo_compra_nivel_id"
                :options="itemsTiposNivel"
                option-label="descripcion"
                option-value="id"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
                label="Categoría de tipo de compra"
                options-dense
                emit-value
                map-options
                @update:model-value="getTipoCompraNivel()"
              ></q-select>
            </div>
            <div class="col-xs-12">
              <q-select
                v-model="form.tipo_compra_id"
                :options="itemsTipos"
                option-label="descripcion"
                option-value="id"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
                label="Tipo compra"
                options-dense
                emit-value
                map-options
              ></q-select>
            </div>
            <div class="col-xs-12">
              <q-input
                v-model="form.detalle"
                label="Detalle"
                class="tu"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
                autogrow
              ></q-input>
            </div>
            <div class="col-xs-12">
              <q-input
                v-model="form.fecha_factura"
                label="Fecha Factura / Recibo"
                dense
                outlined
                label-color="grey"
                dark
                :rules="[v => !!v || 'Requerido']"
                readonly>
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
                      <q-date v-model="form.fecha_factura" mask="DD/MM/YYYY" color="blue-grey" dark>
                        <div class="row items-center justify-end">
                          <q-btn v-close-popup label="Aceptar" color="white" flat />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-xs-12">
              <q-input
                v-model="form.num_factura"
                mask="####################"
                label="Nro. Factura / Recibo"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
              ></q-input>
            </div>
            <div class="col-xs-12">
              <q-input
                v-model="form.cantidad"
                label="Cantidad"
                :rules="[v => !!v || 'Requerido', v => v >= 0 || 'La cantidad debe ser mayor a 0', , v => v < 99999999 || 'La cantidad es muy grande']"
                dense
                outlined
                label-color="grey"
                dark
                @keyup="getSubTotal()"
              ></q-input>
            </div>
            <div class="col-xs-12">
              <q-input
                type="number"
                v-model="form.costo"
                label="Precio unitario"
                :rules="[v => !!v || 'Requerido', v => v >= 0 || 'El precio unitario debe ser mayor a 0', v => v < 9999999999 || 'La cantidad es muy grande']"
                dense
                outlined
                label-color="grey"
                dark
                step="0.01"
                @keyup="getSubTotal()"
              ></q-input>
            </div>
            <div class="col-xs-12">
              <q-input
                v-model="subtotal_format"
                label="Sub. total"
                dense
                outlined
                label-color="grey"
                dark
                disable
                :rules="[v => v !== 0 || 'El subtotal no puede ser igual a 0']"
              ></q-input>
            </div>
          </div>
        </q-card-section>
        <q-separator class="bg-pragma" v-if="form.tipo_compra_id == 1 || form.tipo_compra_id == 7"></q-separator>
        <q-card-section class="text-white" v-if="form.tipo_compra_id == 1 || form.tipo_compra_id == 7">
          <div class="row">
            <div class="col-xs-6 flex items-center">
              Activos fijos
            </div>
            <div class="col-xs-6 text-right">
              <span class="q-pr-xs" v-if="form.cantidad !== null && form.cantidad > 0">Cantidad: {{activos_fijos.length}}/{{form.cantidad}}</span>
              <q-btn class="bg-pragma" icon="add" round size="sm" @click="addAcitvoFijo()"></q-btn>
              <q-toggle v-model="view_activo_fijo" size="xs"></q-toggle>
            </div>
          </div>
        </q-card-section>
        <q-separator class="bg-pragma" v-if="form.tipo_compra_id == 1 || form.tipo_compra_id == 7"></q-separator>
        <q-card-section v-if="view_activo_fijo && (form.tipo_compra_id == 1 || form.tipo_compra_id == 7)">
          <q-list dark bordered separator>
            <q-slide-item
              @right="opt => onRight(index, opt)"
              right-color="negative"
              @left="opt => onLeft(index, activo_fijo, opt)"
              left-color="primary"
              v-for="(activo_fijo, index) in activos_fijos"
              :key="index"
              @click="editActivoFijo(index, activo_fijo)"
              :class="index%2 == 0 ? 'bg-grey-9' : 'bg-grey-8'"
            >
              <template v-slot:right>
                <q-icon name="delete" />
              </template>

              <template v-slot:left>
                <q-icon name="content_copy" />
              </template>
              
              <q-item
                clickable
                v-ripple
                class="text-uppercase"
              >
                <q-item-section>
                  <q-item-label>Descripción: {{activo_fijo.descripcion}}</q-item-label>
                  <q-item-label caption lines="2">Asignación: {{activo_fijo.asignacion}}</q-item-label>
                </q-item-section>

                <q-item-section side top>
                  <q-item-label caption>{{index + 1}}</q-item-label>
                </q-item-section>
              </q-item>
            </q-slide-item>
          </q-list>
        </q-card-section>
        <q-card-actions>
          <div class="row q-pa-sm full-width items-center text-center">
            <div class="col-xs-6 q-pr-sm">
              <q-btn
                v-if="!form.edit"
                label="Cancelar"
                color="negative"
                @click="closeDialog()"
                icon="clear"
                class="full-width"
              ></q-btn>
            </div>
            <div class="col-xs-6 q-pl-sm">
              <q-btn
                type="submit"
                label="Rendir"
                color="positive"
                icon="save"
                class="full-width"
                :loading="loading"
                v-if="!(form.tipo_compra_id == 7 || form.tipo_compra_id == 1) || ~~form.cantidad == activos_fijos.length"
              ></q-btn>
              <q-btn
                type="submit"
                label="Rendir"
                color="grey"
                icon="save"
                class="full-width"
                :loading="loading"
                v-if="(form.tipo_compra_id == 7 || form.tipo_compra_id == 1) && ~~form.cantidad !== activos_fijos.length"
              ></q-btn>
            </div>
          </div>
        </q-card-actions>
      </q-form>
    </q-card>

    <!-- Dialog de Agregación/Edición de activo fijo -->
    <q-dialog
      v-model="activo_fijo_dialog"
      style="max-width: 500px"
      class="custom-font text-uppercase"
    >
      <q-card dark class="pragma-black">
        <q-form @submit.prevent="saveActivoFijo()">
          <q-card-section class="q-pa-none">
            <q-toolbar class="bg-pragma text-white shadow-2 rounded-borders">
              <q-btn flat label="Activo fijo" />
              <q-space />
              <q-btn
                v-if="!form.edit"
                icon="clear"
                @click="() => { activo_fijo_dialog = false; resetFormActivo()}"
                flat
              ></q-btn>
            </q-toolbar>
          </q-card-section>
          <q-card-section>
            <div class="row">
              <div class="col-xs-12">
                <q-input
                  v-model="form_activo.descripcion"
                  label="Descripción específica"
                  class="tu"
                  autogrow
                  :rules="[v => !!v || 'Requerido']"
                  outlined
                  dense
                  label-color="grey"
                  dark
                />
              </div>
              <div class="col-xs-12">
                <q-input
                  v-model="form_activo.serie"
                  label="Nº Serie / Modelo / Código / Placa / Chasis"
                  class="tu"
                  autogrow
                  :rules="[v => !!v || 'Requerido']"
                  outlined
                  dense
                  label-color="grey"
                  dark
                />
              </div>
              <div class="col-xs-12">
                <q-input
                  v-model="form_activo.asignacion"
                  label="Asignación"
                  class="tu"
                  autogrow
                  :rules="[v => !!v || 'Requerido']"
                  outlined
                  dense
                  label-color="grey"
                  dark
                />
              </div>
              <div class="col-xs-12">
                <q-input
                  v-model="form_activo.actividad_especifica"
                  label="Actividad Especifica"
                  class="tu"
                  autogrow
                  :rules="[v => !!v || 'Requerido']"
                  outlined
                  dense
                  label-color="grey"
                  dark
                />
              </div>
              <div class="col-xs-4">
                <q-checkbox v-model="form_activo.nuevo" label="Nuevo" color="red-8"/>
              </div>
              <div class="col-xs-4">
                <q-checkbox v-model="form_activo.reemplazo" label="Reemplazo" color="red-8"/>
              </div>
              <div class="col-xs-4">
                <q-checkbox v-model="form_activo.garantia" label="Garantía" color="red-8"/>
              </div>
            </div>
          </q-card-section>
          <q-card-actions>
            <div class="row q-pa-sm full-width items-center text-center">
              <div class="col-xs-6 q-pr-sm">
                <q-btn
                  v-if="!form.edit"
                  label="Cancelar"
                  color="negative"
                  @click="() => { activo_fijo_dialog = false; resetFormActivo()}"
                  icon="clear"
                  class="full-width"
                ></q-btn>
              </div>
              <div class="col-xs-6 q-pl-sm">
                <q-btn
                  type="submit"
                  label="Guardar"
                  color="positive"
                  icon="save"
                  class="full-width"
                  :loading="loading"
                ></q-btn>
              </div>
            </div>
          </q-card-actions>
        </q-form>
      </q-card>
    </q-dialog>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import axios from 'axios'
import moment from 'moment'
import { useQuasar } from 'quasar'

export default {
  setup () {
    // Variables reactivas y no reactivas
    const bus = inject('bus')
    const dialog = ref(false)
    const vmoment = moment
    const $q = useQuasar()

    const form = ref({})
    const form_activo = ref({
      nuevo: true,
      reemplazo: false,
      garantia: false
    })
    const unidades = ref([])
    const itemsTipos = ref([])
    const itemsTiposNivel = ref([])
    const subtotal_format = ref(0)
    const loading = ref(false)
    const view_activo_fijo = ref(true)
    const activos_fijos = ref([])
    const activo_fijo_dialog = ref(false)
    const edit = ref(null)

    // Métodos y funciones del componente
    const getUnidades = async () => {
      let res = await axios.get('unidad')
      unidades.value = res.data
    }

    const getItemsTipos = async () => {
      try {
        let res = await axios.get('item-tipo')
        itemsTiposNivel.value = res.data
      } catch (error) {
        console.log(error)
      }
    }

    const getTipoCompraNivel = async () => {
      try {
        form.value.tipo_compra_id = null
        let res = await axios.post('item-tipo/nivel', {item_tipo_id: form.value.tipo_compra_nivel_id})
        itemsTipos.value = res.data
      } catch (error) {
        console.log(error)
      }
    }

    const getSubTotal = () => {
      if (form.value.cantidad !== null && form.value.costo !== null && form.value.cantidad > 0 && form.value.costo > 0) {
        form.value.sub_total = form.value.cantidad * form.value.costo
        subtotal_format.value = form.value.sub_total.toFixed(2)
      } else {
        form.value.sub_total = 0
      }
    }

    const rendirItem = async () => {
      try {
        if ((form.value.tipo_compra_id == 7 || form.value.tipo_compra_id == 1) && eval(form.value.cantidad) !== activos_fijos.value.length) {
          return $q.notify({
            color: 'negative',
            message: 'La cantidad de activos fijos debe ser igual a la cantidad descrita en el formulario'
          })
        }
        form.value.fecha_factura = moment(form.value.fecha_factura, 'DD/MM/YYYY').format('YYYY-MM-DD')
        form.value.activos_fijos = activos_fijos.value
        form.value.tipocompra_id = form.value.tipo_compra_id
        loading.value = true
        await axios.post('rendir/solicitud/item/', form.value)
        $q.notify({
          message: 'Ítem rendido',
          color: 'positive'
        })
        bus.emit('refreshRendicion')
        closeDialog()
      } catch (error) {
        console.log(error)
        loading.value = false
      }
      closeDialog()
    }

    const closeDialog = () => {
      form.value = {}
      resetFormActivo()
      activos_fijos.value = []
      subtotal_format.value = 0
      loading.value = false
      dialog.value = false
    }

    const addAcitvoFijo = () => {
      if (activos_fijos.value.length >= form.value.cantidad) {
        return $q.notify({
          message: 'No se puede agregar más activos fijos',
          color: 'negative'
        })
      }
      activo_fijo_dialog.value = true
      edit.value = null
    }

    const saveActivoFijo = () => {
      const data = {
        ...form_activo.value
      }
      if (edit.value !== null) {
        activos_fijos.value[edit.value] = data
      } else {
        activos_fijos.value.push(data)
      }
      resetFormActivo()
      activo_fijo_dialog.value = false
    }

    const editActivoFijo = (index, activo_fijo) => {
      edit.value = index
      form_activo.value = {
        ...activo_fijo
      }
      activo_fijo_dialog.value = true
    }

    const resetFormActivo = () => {
      edit.value = null
      form_activo.value = {
        nuevo: true,
        reemplazo: false,
        garantia: false
      }
    }

    const onRight = (index, {reset}) => {
      activos_fijos.value.splice(index, 1)
      reset()
    }

    const onLeft = (index, activo_fijo, {reset}) => {
      if (activos_fijos.value.length >= form.value.cantidad) {
        reset()
        return $q.notify({
          message: 'No se puede agregar más activos fijos',
          color: 'negative'
        })
      }
      edit.value = null
      form_activo.value = {
        ...activo_fijo
      }
      delete form_activo.value.asignacion
      activo_fijo_dialog.value = true
      reset()
    }

    // Creación del componente
    getUnidades()
    getItemsTipos()
    bus.on('openDialogFormRendirItem', (item) => {
      let tipo_compra_id = null
      if (item.tipo_compra.items_tipo_id) {
        tipo_compra_id = item.tipo_id
      } else {
        tipo_compra_id = null
      }
      form.value = {
        item_id: item.id,
        solicitud_id: item.solicitud_id,
        unidad_id: item.unidad_id,
        tipo_compra_nivel_id: item.tipo_compra.items_tipo_id ? item.tipo_compra.items_tipo_id : null,
        tipo_compra_id: item.tipo_compra.items_tipo_id ? item.tipo_id : null,
        detalle: item.detalle,
        cantidad: ~~item.cantidad,
        costo: item.costo,
        sub_total: item.subtotal
      }
      getTipoCompraNivel()
      form.value.tipo_compra_id = tipo_compra_id
      subtotal_format.value = item.subtotal
      getSubTotal()
      dialog.value = true
    })

    // Retorno de variables al template
    return {
      dialog,
      closeDialog,
      form,
      form_activo,
      unidades,
      itemsTipos,
      itemsTiposNivel,
      getSubTotal,
      rendirItem,
      subtotal_format,
      vmoment,
      loading,
      view_activo_fijo,
      activos_fijos,
      activo_fijo_dialog,
      addAcitvoFijo,
      saveActivoFijo,
      editActivoFijo,
      resetFormActivo,
      onRight,
      onLeft,
      edit,
      getTipoCompraNivel
    }
  }
}
</script>

<style>

</style>